import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Cover from '../components/cover/cover'
import Layout from "../components/layout"
import SEO from "../components/seo"
import TeamTile from '../components/team-tile/team-tile'

import PledgeForm from "../components/form/pledge"

import cover from "../images/donate-cover.jpg"
import { StaticImage } from "gatsby-plugin-image"

const DonatePage = () => {

    const data = useStaticQuery(graphql`
    query {
        allContentfulTeam {
            nodes {
              about {
                about
              }
              image {
                file {
                  url
                }
              }
              id
              name
              role
            }
          }
        }
    `)
    
    return (
  <Layout>
    <SEO title="We Clothe Them - Donate" />
    <Cover image={cover} title={`Donate`} />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <p className={`margin-bottom`}>Support us in our pursuit to spread happiness and joy among those who need support and for each of us to experience the joy of giving.</p>
        
        <div className={`margins-v`}>
            <h6 className={`letter-spaced-heading`}>Donation Pledge</h6>
            <h2 className={`margin-bottom`}>Pledge a donation</h2>
            <div className={`margins-v`}>
                <PledgeForm />
            </div>
        </div>

        <hr className={`margins`} />

        <div className={`margins-v`}>
            <h6 className={`letter-spaced-heading`}>Donate Directly</h6>
            <h2>Donate with mobile wallets</h2>
            <div className={`margins-v`}>
                <div className={`mobile-wallets`}>
                    <div className={`logo`}>
                        <StaticImage src={`../images/paytm.png`} height={100} />
                    </div>
                    <p className={`margins-h`}>OR</p>
                    <div className={`logo`}>
                        <StaticImage src={`../images/GPay.png`} height={100} />
                    </div>
                </div>
                <h3 className={`margin-bottom`}>+91 99992 98196</h3>
                {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
            </div>
        </div>
      </div>
    </section>
  </Layout>
    )
}

export default DonatePage